import { SelectOption } from "atoms/forms/select";
import UserBookmarkCountSortOption from "models/enumerations/sorting/user-bookmarks/user-bookmark-count-sort-option";
import SelectFormField from "molecules/form-fields/select-form-field";
import React from "react";
import { CountSortByValueToNameMap } from "utilities/bookmark-utils";
import { t } from "utilities/localization-utils";
interface BookmarkCountSortByProps {
    sort?: UserBookmarkCountSortOption;
    onChange: (option: SelectOption | undefined) => void;
    showBookOrder?: boolean;
    showCollection?: boolean;
}

const BookmarkCountSortBy = ({
    sort,
    onChange,
    showBookOrder,
    showCollection,
}: BookmarkCountSortByProps) => {
    const options: SelectOption[] = [
        {
            data: UserBookmarkCountSortOption.BookmarkCreatedOnAscending,
            value: UserBookmarkCountSortOption.BookmarkCreatedOnAscending.toString(),
            label: t(
                CountSortByValueToNameMap[
                    UserBookmarkCountSortOption.BookmarkCreatedOnAscending
                ]
            ),
        },
        {
            data: UserBookmarkCountSortOption.BookmarkCreatedOnDescending,
            value: UserBookmarkCountSortOption.BookmarkCreatedOnDescending.toString(),
            label: t(
                CountSortByValueToNameMap[
                    UserBookmarkCountSortOption.BookmarkCreatedOnDescending
                ]
            ),
        },
        ...[
            ...(showBookOrder
                ? [
                      {
                          data: UserBookmarkCountSortOption.BookOrder,
                          value: UserBookmarkCountSortOption.BookOrder.toString(),
                          label: t(
                              CountSortByValueToNameMap[
                                  UserBookmarkCountSortOption.BookOrder
                              ]
                          ),
                      },
                  ]
                : []),
        ],
        ...[
            ...(showCollection
                ? [
                      {
                          data: UserBookmarkCountSortOption.Collection,
                          value: UserBookmarkCountSortOption.Collection.toString(),
                          label: t(
                              CountSortByValueToNameMap[
                                  UserBookmarkCountSortOption.Collection
                              ]
                          ),
                      },
                  ]
                : []),
        ],
    ];

    const handleOnChange = (newVal: SelectOption | undefined) => {
        onChange(newVal?.data);
    };
    return (
        <>
            <SelectFormField
                ariaLabelOnly
                label={t("sortBy")}
                value={sort?.toString()}
                onChange={handleOnChange}
                options={options}
            />
        </>
    );
};

export default BookmarkCountSortBy;
